import { URL_OFFER_PROPOSAL_ARCHIVE } from '@tools/routes/routes';
import { flashBagError } from '@tools/flashbag';
import requests from '@tools/requests';
import Logger from '@tools/logger/logger';

export const apiArchiveProposal = async (proposalId: number): Promise<boolean> => {
  try {
    await requests.patch(URL_OFFER_PROPOSAL_ARCHIVE.replace('{id}', String(proposalId)));
    return true;
  } catch (error) {
    flashBagError();
    Logger.error(error);
  }

  return false;
};
